// extracted by mini-css-extract-plugin
export default {"container":"BlogCard_container__RxVKc"};